export default __webpack_public_path__ + "static/media/isoftbet-mono.107b9d92.svg";